module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "expand-wrap",
    on: {
      "expansion": _vm.handleExpansion
    }
  }, [(_vm.expanded) ? _c('span', {
    staticClass: "expand-wrap--icon expand-wrap--icon__minus"
  }, [_vm._v("−")]) : _c('span', {
    staticClass: "expand-wrap--icon expand-wrap--icon__plus"
  }, [_vm._v("+")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc0e323"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/ExpandButton.vue
// module id = 107
// module chunks = 3